export default {
  all_workspaces: "All Workspaces",
  info_administrators: "Administrators",
  info_organisation: "Organisation",
  info_timezone: "Timezone",
  info_notes: "Notes",
  is_this_yours: "Is this your Workspace?",
  remaining_workspaces: "Remaining Workspaces",
  status_attachment_change_requests: "Attachment change requests",
  status_data_change_requests: "Data change requests",
  status_issues: "Open Issues",
  status_location_change_requests: "Location change requests",
  status_work_orders: "Open Work Orders",
  subtitle: "Workspace Home",
  title: "Workspaces",
  title_info: "Information",
  title_status: "Aggregate status",
  open_events: "Open events",
  not_implemented: "Not implemented",
}
